import apiFor from './apiInterceptor';
const api = apiFor('/coreService');
const API_URIS = {
	product_attribute: process.env.REACT_APP_NODE_PRODUCT_ATTRIBUTE_API_URL,
	product_attribute_value: process.env.REACT_APP_NODE_PRODUCT_ATTRIBUTE_VALUES_API_URL,
	product_variant: process.env.REACT_APP_NODE_PRODUCT_VARIANT_API_URL,
	stock_location: process.env.REACT_APP_NODE_STOCK_LOCATION_API_URL,
	stock_movement: process.env.REACT_APP_NODE_STOCK_MOVEMENT_API_URL,
	stock_warehouse: process.env.REACT_APP_NODE_STOCK_WAREHOUSE_API_URL,
	category: process.env.REACT_APP_NODE_CATEGORY_API_URL,
	brand: process.env.REACT_APP_NODE_BRAND_API_URL,
	attachment: '/attachment',
	order: process.env.REACT_APP_NODE_ORDER_API_URL,
	order_line: process.env.REACT_APP_NODE_ORDER_LINE_API_URL,
	caisse: process.env.REACT_APP_NODE_CAISSE_API_URL,
	session: process.env.REACT_APP_NODE_SESSION_API_URL,
	customer: process.env.REACT_APP_NODE_CUSTOMER_API_URL,
	employee: process.env.REACT_APP_NODE_EMPLOYEE_API_URL1,
	contrat: process.env.REACT_APP_NODE_CONTRAT_API_URL,
	colis: process.env.REACT_APP_NODE_COLIS_API_URL,
	employe: '/moduleCore/employe',
	user: '/moduleCore/user',
	pointage: process.env.REACT_APP_NODE_POINTAGE_API_URL,
	employeeJob: process.env.REACT_APP_API_EMPLOYEEJOB_API_URI,
	enlevement: process.env.REACT_APP_API_ENLEVEMENT_API_URI,
	EnlevementLine: process.env.REACT_APP_API_ENLEVEMENT_API_URI,
	tracking: "/tracking",
	planning: process.env.REACT_APP_NODE_PLANNING_API_URL,
	livraison: process.env.REACT_APP_NODE_LIVRAISON_API_URL,
	order_movement: process.env.REACT_APP_NODE_ORDER_MOVEMENT_API_URL,
	company: process.env.REACT_APP_NODE_COMPANY_API_URL,
	module: process.env.REACT_APP_NODE_MODULE_API_URL,
	promo: process.env.REACT_APP_NODE_STOCK_PROMO_API_URL,
	orderFabrication: process.env.REACT_APP_NODE_ORDER_FABRICATION_API_URL,
	nomenclature: process.env.REACT_APP_NODE_NOMENCLATURE_API_URL,
	contrat: process.env.REACT_APP_NODE_CONTRAT_API_URL,
	delivery_credential: process.env.REACT_APP_NODE_DELIVERY_CREDENTIAL_API_URL,
	delivery_provider: process.env.REACT_APP_NODE_DELIVERY_PROVIDER_API_URL,
	voiture: process.env.REACT_APP_NODE_VOITURE_API_URL,
	contrat1: process.env.REACT_APP_NODE_CONTRAT_API_URL1,
	domain: process.env.REACT_APP_GET_ALL_OVH_DOMAINS_URL,
	server: process.env.REACT_APP_GET_SERVER_URL,
	telephony: process.env.REACT_APP_TELEPHONY_URL,
	workspace: process.env.REACT_APP_API_WORKSPACE_API_URI,
	group: process.env.REACT_APP_API_GROUP_API_URI,
	project: process.env.REACT_APP_API_PROJECT_API_URI,
	kanbanBoard: process.env.REACT_APP_API_KANBANBOARD_API_URI,
	column: process.env.REACT_APP_API_COLUMN_API_URI,
	ticket: process.env.REACT_APP_API_TICKET_API_URI,
	comment: process.env.REACT_APP_API_COMMENT_API_URI,
	statusChange: process.env.REACT_APP_API_STATUSCHANGE_API_URI,
	society: process.env.REACT_APP_SOCIETY_URL,
	store2000_client: process.env.REACT_APP_STORE_2000_CLIENT_URL,
	dm_client: process.env.REACT_APP_DM_CLIENT_URL,
	poste: process.env.REACT_APP_API_POSTE_API_URI,
	departement: process.env.REACT_APP_API_DEPARTEMENT_API_URI,
	role: process.env.REACT_APP_API_ROLE_API_URI,
	session: '/moduleCore/session',
	achat: '/achat',
	stock: '/stock',
	devis: '/devis',
	planning: '/planning',
	email: '/email/dmk',
	documentLayouts: '/document-layouts',
	models: '/models',
	domain_contact: "/domain/contact",
	lead: "/boite-mailing/leads",
	stat: "/statistique",
	appels: "/appels",
	analytics: "/analytics",
	host: "/host",
	compteTelephonie: "/appels/comptes",
	record: "/record",
	rappel: "/rappel",
	avis: "/avis",
	fiche:"/google",
	place:"/place",
	aidashbord:"/api/ai-dashboard/",
	leadresponse:"email",
	relanceFacture: "/relance-facture",
	charge:"/charge"
};

export const getAPI = async (type, addedUrl = '', signal = null) => {
	if (!API_URIS[type]) {
		console.log(`Invalid API type: ${type}`);
		return null;
	}
	const url = API_URIS[type] + addedUrl;
	console.log("url",url)
	try {
		const response = await api.get(url, { signal });
		return response.data;
	} catch (error) {
		if (error.code !== 'ERR_CANCELED') {
			console.log(`API Error on GET ${url}:`, error.response?.data || error.message);
		}
		return null;
	}
};

export const postAPI = async (type, newData, addedUrl = '', signal = null) => {
	if (!API_URIS[type]) {
		console.log(`Invalid API type: ${type}`);
		return null;
	}
	const url = API_URIS[type] + addedUrl;
	try {
		// Axios automatically handles JSON.stringify for objects.
		const response = await api.post(url, newData, { signal });
		return response.data;
	} catch (error) {
		if (error.code === 'ERR_CANCELED') return null;

		// Normalize error message
		const errorMsg =
			error.response?.data?.message ||
			error.response?.data?.error ||
			error.message ||
			'Unknown error occurred';

		console.log(`API Error on POST ${url}:`, errorMsg);
		// 🔥 Re-throw so caller can handle it
		throw new Error(errorMsg);
	}
};

export const putAPI = async (type, newData, addedUrl = '', signal = null) => {
	if (!API_URIS[type]) {
		console.log(`Invalid API type: ${type}`);
		return null;
	}
	const url = API_URIS[type] + addedUrl;
	try {
		const response = await api.put(url, newData, { signal });
		return response.data;
	} catch (error) {
		if (error.code !== 'ERR_CANCELED') {
			console.log(`API Error on PUT ${url}:`, error.response?.data || error.message);
		}
		return (error.response?.data || error.message);
	}
};

export const deleteAPI = async (type, addedUrl = '', signal = null) => {
	if (!API_URIS[type]) {
		console.log(`Invalid API type: ${type}`);
		return null;
	}
	const url = API_URIS[type] + addedUrl;
	try {
		const response = await api.delete(url, { signal });
		return response.data;
	} catch (error) {
		if (error.code !== 'ERR_CANCELED') {
			console.log(`API Error on DELETE ${url}:`, error.response?.data || error.message);
		}
		return null;
	}
};

export const deleteAPIWithBody = async (type, addedUrl = '', data, signal = null) => {
	if (!API_URIS[type]) {
		console.log(`Invalid API type: ${type}`);
		return null;
	}
	const url = API_URIS[type] + addedUrl;
	try {
		const response = await api.delete(url, data, { signal });
		return response.data;
	} catch (error) {
		if (error.code !== 'ERR_CANCELED') {
			console.log(`API Error on DELETE ${url}:`, error.response?.data || error.message);
		}
		return null;
	}
};
